import { Contact, Footer, Gallery, Hero, NavBar, Tech } from './components';
import { BrowserRouter } from 'react-router-dom';

function App() {
  return (
    <BrowserRouter>
      <div className="relative bg-primary text-txt-primary">
        <div className="bg-hero-pattern bg-cover bg-no-repeat bg-center h-screen">
          <NavBar />
          <Hero />
        </div>
        <Tech />
        <Gallery />
        <Contact />
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
